import "regenerator-runtime";
import "./index.css";
import { EventBus, EventTypes } from "./consts/const-event-types";

/*
To add new components, import them here and add them to the 'components'-array below.
Add an appropriate selectorName for use in DOM (fx: <div data-component="header"></div>):
*/
import App from "./components/app";
import ExampleComponent from "./components/example-component/example-component";
import UserItem from "./components/user-item/user-item";
import MenuDropdown from "./components/menu-dropdown/menu-dropdown";
import MenuMain from "./components/menu-dropdown/menu-main";
import Accordion from "./components/accordion/accordion";
import MediaPlayer from "./components/media-player/media-player";
import Header from "./components/header/header";
import AnchorMenu from "./components/anchor-menu/anchor-menu";
import GlobalSearch from "./components/search/global-search";
import IframeTab from "./components/iframe-tab/iframe-tab";
import ServiceCode from "./components/service-code/service-code";
import RichText from "./components/rich-text/rich-text";
import MailchimpSignup from "./components/mailchimp-signup/mailchimp-signup";
import GoogleMap from "./components/google-map/google-map";
import Ical from "./components/ical/ical";
import GlobalAlert from "./components/global-alert/global-alert";
import PriceSaveCalculator from "./components/pricesave-calculator/pricesave-calculator";
import QuestionnaireModule from "./components/questionnaire/questionnaire";
import GuidePage from "./components/guidePage/guidePage";
import GuideProgress from "./components/guide-reminder/guide-progress";
import CallMeUp from "./components/call-me-up/call-me-up";
import CandenoLogin from "./components/candeno-login/candeno-login";

//Import lazysizes as early as possible.
import lazySizes from "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/respimg/ls.respimg";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

//Set lazysizes configuration.
lazySizes.cfg.lazyClass = "lazyload";
lazySizes.cfg.loadedClass = "loaded";
lazySizes.cfg.customMedia = {
  "--small": "(max-width: 640px)",
  "--medium": "(max-width: 1024px)",
  "--large": "(min-width:1440px)",
};

const components = [
  { Class: App, selectorName: "app" },
  { Class: ExampleComponent, selectorName: "example-component" },
  { Class: UserItem, selectorName: "user-item" },
  { Class: MenuDropdown, selectorName: "menu-dropdown" },
  { Class: MenuMain, selectorName: "menu-main" },
  { Class: Accordion, selectorName: "accordion" },
  { Class: MediaPlayer, selectorName: "media-player" },
  { Class: Header, selectorName: "header" },
  { Class: AnchorMenu, selectorName: "anchor-menu" },
  { Class: GlobalSearch, selectorName: "global-search" },
  { Class: IframeTab, selectorName: "iframe-tab" },
  { Class: ServiceCode, selectorName: "service-code" },
  { Class: RichText, selectorName: "rich-text" },
  { Class: MailchimpSignup, selectorName: "mailchimp-signup" },
  { Class: GoogleMap, selectorName: "google-map" },
  { Class: Ical, selectorName: "ical" },
  { Class: GlobalAlert, selectorName: "global-alert" },
  { Class: PriceSaveCalculator, selectorName: "pricesave-calculator" },
  { Class: QuestionnaireModule, selectorName: "quesionnaire-module" },
  { Class: GuidePage, selectorName: "guidePage" },
  { Class: GuideProgress, selectorName: "guide-progress" },
  { Class: CallMeUp, selectorName: "call-me-up-form" },
  { Class: CandenoLogin, selectorName: "candeno-login" },
];

/*
 * ComponentInstantiator traverses the DOM-tree and looks for [data-component='] attributes.
 */
class ComponentInstantiator {
  constructor() {
    this.createComponents();
    this.dispatchReady();
    return this;
  }

  createComponents() {
    this.componentsInstantiated = {};

    components.map((component) => {
      const nodes = [];
      // select all DOM-nodes with the data-component attribute:
      const nodeItems = [...document.querySelectorAll("[data-component='" + component.selectorName + "']")];

      nodeItems.map((nodeItem) => {
        // instantiate component with nodeItem as param:
        nodes.push(new component.Class(nodeItem));
      });

      // add to componentsList object:
      if (nodes.length) this.componentsInstantiated[component.selectorName] = nodes;
    });
  }

  dispatchReady() {
    const event = new CustomEvent(EventTypes.ALL_COMPONENTS_READY);
    EventBus.dispatchEvent(event);
  }

  getComponents(selectorName) {
    return selectorName ? this.componentsInstantiated[selectorName] : this.componentsInstantiated;
  }
}

//SERVICEWORKER FOR PWA

if ("serviceWorker" in navigator) {
  //console.log("get serviceworker");
  window.addEventListener("load", function () {
    navigator.serviceWorker
      .register("/serviceWorker.js")
      .then((res) => {})
      .catch((err) => console.log("service worker not registered", err));
  });
}

/* Make your App accessible via window.App */
window.App = new ComponentInstantiator();

/* Access components list */
// console.log('components on this page', window.App.getComponents())
